import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useStyles } from "./ValetRequestMonitorTable.styles";
import "../../ResponsiveTable/_responsive.table.css";
import useCurrentFacilityTimezone from "../../../hooks/useCurrentFacilityTimezone";
import { useEnqueueSnackbar } from "../../../hooks/useEnqueueSnackbar";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ValetInventoryDetailDrawer from "../../ValetInventory/ValetInventoryDetailDrawer/ValetInventoryDetailDrawer";
import apiClient from "../../../auth/apiClient";
import RequestMonitorService from "../../../services/RequestMonitorService";
import WaitTimeCell from "./WaitTimeCell";

const ValetRequestMonitorTable = ({ results = [], getTierColor }) => {
  const classes = useStyles();
  const { timeZone } = useCurrentFacilityTimezone();
  const enqueueSnackbar = useEnqueueSnackbar();
  const [selectedCredential, setSelectedCredential] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [retrievedByEmployees, setRetrievedByEmployees] = useState([]);

  const requestMonitorService = new RequestMonitorService(apiClient);

  const onRowClick = (result) => {   
    setSelectedCredential(result);
    setDrawerOpen(true);
  }

  const onDrawerClose = () => {
    setSelectedCredential(null);
    setDrawerOpen(false)
  }

  useEffect(() => {
    const accessHolderIds = results
      ?.map(item => item.retrievedBy?.trim())
      .filter(Boolean)
      .filter((id, index, arr) => arr.indexOf(id) === index);

    if (accessHolderIds?.length === 0) return;

    const getRetrievedByEmployees = async () => {
      try {
        const request = { accessHolderIds, };
        const response = await requestMonitorService.getValetEmployees(request);
        const data = response?.data;
        setRetrievedByEmployees(Array.isArray(data) ? data : []);
      } catch (err) {
        enqueueSnackbar("Failed to fetch retrieved by employees", {
          variant: "error",
        });
      }
    };

    getRetrievedByEmployees();
  }, [results]);

  const getRetrievedByEmp = (retrievedBy) => {
    if (!retrievedBy || !retrievedByEmployees.length ) return "";
    const retrievedByEmp = retrievedByEmployees
      .find((emp) => emp.accessHolderID === retrievedBy);
    return retrievedByEmp ? [retrievedByEmp.firstName, retrievedByEmp.lastName].filter(Boolean).join(" ") : ""
  };

  return (
    <>
      <table className={clsx(classes.resultTable, "a1-responsive")}>
        <thead className={clsx(classes.thHeader)}>
          <tr>
            <th className={clsx([classes.resultHeader])}>Ticket Number</th>
            <th className={clsx([classes.centerHeader])}>Wait Time (Mins)</th>
            <th className={clsx([classes.centerHeader, "hide-in-mobile"])}>Payment Status</th>
            <th className={clsx([classes.centerHeader, "hide-in-mobile"])}>License Plate</th>
            <th className={clsx([classes.centerHeader, "hide-in-mobile"])}>Valet Area</th>
            <th className={clsx([classes.centerHeader, "hide-in-mobile"])}>Parked Space</th>
            <th className={clsx([classes.centerHeader, "hide-in-mobile"])}>Customer</th>
            <th className={clsx([classes.centerHeader])}>Retrieval Employee</th>
          </tr>
        </thead>

        <tbody>
          {results.map((result) => {
            return (
              <tr
                key={result.ticketNumber}
                className={classes.clickableRow}
                onClick={() => onRowClick(result)} data-selected={result.contextID === selectedCredential?.contextID}
                data-testid="requestmonitor-row"
              >
                <td
                  data-column="Ticket Number"
                  className={clsx([classes.column])}
                >
                  {result.ticketNumber}
                </td>
                <td
                  data-column="Wait Time"
                  className={clsx([classes.column, classes.centerAlign])}
                >
                  <WaitTimeCell requestedDate={result.requestedDate} timeZone={timeZone} getTierColor={getTierColor} classes={classes} />
                </td>
                <td
                  data-column="Payment Status"
                  className={clsx([classes.column, classes.centerAlign, "hide-in-mobile"])}
                >
                  <CheckCircleIcon className={clsx([classes.checkIcon])} />
                </td>
                <td
                  data-column="License Plate"
                  className={clsx([classes.column, classes.centerAlign, "hide-in-mobile"])}
                >
                  {result.licensePlate}
                </td>
                <td
                  data-column="Valet Area"
                  className={clsx([classes.column, classes.centerAlign, "hide-in-mobile"])}
                >
                  {result.entityName}
                </td>
                <td
                  data-column="Parked Space"
                  className={clsx([classes.column, classes.centerAlign, "hide-in-mobile"])}
                >
                  {result.parkedSpace}
                </td>
                <td
                  data-column="Customer"
                  className={clsx([classes.column, classes.centerAlign, "hide-in-mobile"])}
                >
                  {[result.firstName, result.lastName].filter(Boolean).join(" ")}
                </td>
                <td
                  data-column="Retrieval Employee"
                  className={clsx([classes.column, classes.centerAlign])}
                >
                  {getRetrievedByEmp(result.retrievedBy)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <ValetInventoryDetailDrawer credential={selectedCredential} open={drawerOpen} isAutoRefresh ={true} onClose={(success) => onDrawerClose()} />
    </>
  );
};

export default ValetRequestMonitorTable;
